<template>
  <div class="row q-pa-sm q-gutter-sm">
    <q-btn
      no-caps
      unelevated
      size="sm"
      color="grey-6"
      text-color="white"
      label="コンテナ追加"
      icon-right="arrow_drop_down"
      :class="action === 'new' ? 'bg-brand' : ''"
    >
      <q-menu>
        <q-list>
          <q-item clickable v-close-popup @click="onChangeAction('new', 'bubble')">
            <q-item-section>bubble</q-item-section>
          </q-item>
          <q-item clickable v-close-popup @click="onChangeAction('new', 'carousel')">
            <q-item-section>carousel</q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </q-btn>
    <q-btn
      no-caps
      unelevated
      size="sm"
      color="grey-6"
      text-color="white"
      label="テンプレート"
      :class="action === 'template' ? 'bg-brand' : ''"
      @click="onChangeAction('template')"
    />
    <q-btn
      no-caps
      unelevated
      size="sm"
      color="grey-6"
      text-color="white"
      label="JSON表示・編集"
      icon="integration_instructions"
      :class="action === 'json' ? 'bg-brand' : ''"
      @click="onChangeAction('json')"
    />
    <q-btn
      no-caps
      unelevated
      size="sm"
      color="grey-6"
      text-color="white"
      label="テスト送信"
      :class="action === 'test' ? 'bg-brand' : ''"
      @click="handleSendingTestModal()"
    />
  </div>
  <FlexMessageTemplateModal
    v-if="flexTemplateModalVisible"
    :modalVisible="flexTemplateModalVisible"
    :template="value"
    :imgFile="imgFile"
    :previewImageUrl="previewImageUrl"
    :isMessageChanged="isChanged"
    :isAdmin="isAdmin"
    :isSuper="isSuper"
    :altText="altText"
    @update:selectTemplate="onSelectTemplate"
    @update:closeModal="onCloseModal"
    @onAddTemplate="$emit('onAddTemplate')"
    @update:altText="(val) => $emit('update:altText', val)"
  />
  <FlexMessageJSONModal
    v-if="flexJSONModalVisible"
    v-model="value"
    :modalVisible="flexJSONModalVisible"
    :isAdmin="isAdmin"
    @submitJson="(val) => $emit('initMessage', val)"
    @update:closeModal="onCloseModal"
  />
  <SendingTestModal
    v-if="sendingTestModalVisible"
    :modalVisible="sendingTestModalVisible"
    :flexJson="value"
    :appID="selectedAppId"
    :isFlex="true"
    @update:closeModal="onCloseModal"
  />
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import { IFlexMessageBubble, IFlexMessageCarousel, IFlexMessageTemplate } from '@/utils/types'
import SendingTestModal from '@/components/common/ui/SendingTestModal.vue'
import FlexMessageTemplateModal from '@/components/story/common/flex-message/FlexMessageTemplateModal.vue'
import FlexMessageJSONModal from '@/components/story/common/flex-message/FlexMessageJSONModal.vue'
import FlexMessageTemplateFormModal from '@/components/story/common/flex-message/FlexMessageTemplateFormModal.vue'

@Options({
  components: { FlexMessageTemplateFormModal, FlexMessageJSONModal, FlexMessageTemplateModal, SendingTestModal },
  directives: { maska },
  emits: ['update:modelValue', 'initMessage', 'onAddTemplate', 'update:altText'],
})
export default class TemplateButtons extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  isAdmin!: boolean

  @Prop()
  isSuper!: boolean

  @Prop()
  isChanged!: boolean

  @Prop()
  imgFile!: File

  @Prop()
  previewImageUrl!: string

  @Prop()
  altText!: string

  bubbleTemplate: IFlexMessageBubble = {
    type: 'bubble',
    body: {
      type: 'box',
      layout: 'vertical',
      contents: [],
    },
  }

  carouselTemplate: IFlexMessageCarousel = {
    type: 'carousel',
    contents: [
      {
        type: 'bubble',
        body: {
          type: 'box',
          layout: 'vertical',
          contents: [],
        },
      },
      {
        type: 'bubble',
        body: {
          type: 'box',
          layout: 'vertical',
          contents: [],
        },
      },
    ],
  }

  action = 'new'
  flexTemplateModalVisible = false
  flexJSONModalVisible = false
  sendingTestModalVisible = false

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get selectedAppId() {
    return this.$route.params.app_id
  }

  onChangeAction(type, content = '') {
    this.action = type
    if (type === 'new') {
      if (content === 'bubble') {
        this.$emit('initMessage', this.bubbleTemplate)
      } else {
        this.$emit('initMessage', this.carouselTemplate)
      }
    } else if (type === 'template') {
      this.flexTemplateModalVisible = true
    } else if (type === 'json') {
      this.flexJSONModalVisible = true
    }
  }

  onSelectTemplate(template: IFlexMessageTemplate) {
    if (template.contents) {
      this.$emit('initMessage', template.contents)
      if (!this.altText && template.alt_text) {
        this.$emit('update:altText', template.alt_text)
      }
    }
    this.onCloseModal()
  }

  onCloseModal() {
    this.flexTemplateModalVisible = false
    this.flexJSONModalVisible = false
    this.sendingTestModalVisible = false
  }

  handleSendingTestModal() {
    this.sendingTestModalVisible = true
  }
}
</script>

<style scoped lang="scss">
</style>
